export const fetchSkillsFromLightcast = async (query) => {
  const response = await fetch(`https://server.cooptaleo.com/api/lightcast/skills?q=${encodeURIComponent(query)}`);
  
  const contentType = response.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    const errorText = await response.text();
    console.error("Erreur: réponse non JSON", errorText);
    throw new Error("Réponse non JSON reçue du serveur.");
  }

  const data = await response.json();
  return data;
};
